import { ReactElement } from "react";
import { IFormHandler } from "client/Forms";
import { localize } from "client_legacy/ndaw/culture";
import { ActivityFeedSettingsState } from "./NotificationSettingsDialog";
import { NotificationSection } from "./NotificationSection";
import { Tabs } from "client/Components";

export type HubActivitySectionProps = {
	formHandler: IFormHandler<ActivityFeedSettingsState>;
	canConfigureCommunityFilters: boolean;
};

export const HubActivitySection = (props: HubActivitySectionProps): ReactElement => {
	const {
		formHandler,
		canConfigureCommunityFilters
	} = props;

	return (
		<NotificationSection
			title={localize("_TheHub")}
			trackingId="hub"
		>
			<Tabs>
				<Tabs.Tab
					id="announcement"
					title={localize("_Announcements")}
				>
					<NotificationSection.ItemList>
						<NotificationSection.Item
							label={localize("_Announcements")}
							subtext={localize("_AnnouncementsActivityDescription")}
							attachable={formHandler.for("announcements")
								.for("isEnabled")
								.attachToCheckbox()
							}
						/>

						<NotificationSection.Item
							label={localize("_AnnouncementComments")}
							subtext={localize("_AnnouncementCommentsActivityDescription")}
							attachable={formHandler.for("announcementComments")
								.for("isEnabled")
								.attachToCheckbox()
							}
						/>

						<NotificationSection.Item
							label={localize("_AnnouncementReactions")}
							subtext={localize("_AnnouncementReactionsActivityDescription")}
							attachable={formHandler.for("announcementReactions")
								.for("isEnabled")
								.attachToCheckbox()
							}
						/>

						<NotificationSection.Item
							label={localize("_AnnouncementMentions")}
							subtext={localize("_AnnouncementMentionsActivityDescription")}
							attachable={formHandler.for("announcementCommentMentions")
								.for("isEnabled")
								.attachToCheckbox()
							}
						/>
					</NotificationSection.ItemList>
				</Tabs.Tab>
				{canConfigureCommunityFilters && (
					<Tabs.Tab
						id="community"
						title={localize("_Communities")}
					>
						<NotificationSection.ItemList>
							<NotificationSection.Item
								label={localize("_Communities")}
								subtext={localize("_CommunityActivityDescription")}
								attachable={formHandler.for("community")
									.for("isEnabled")
									.attachToCheckbox()
								}
							/>

							<NotificationSection.Item
								label={localize("_CommunityMembership")}
								subtext={localize("_CommunityMembershipActivityDescription")}
								attachable={formHandler.for("communityMembership")
									.for("isEnabled")
									.attachToCheckbox()
								}
							/>

							<NotificationSection.Item
								label={localize("_MembershipRequests")}
								subtext={localize("_MembershipRequestsActivityDescription")}
								attachable={formHandler.for("communityMembershipRequests")
									.for("isEnabled")
									.attachToCheckbox()
								}
							/>

							<NotificationSection.Item
								label={localize("_CommunityPosts")}
								subtext={localize("_CommunityPostsActivityDescription")}
								attachable={formHandler.for("communityPosts")
									.for("isEnabled")
									.attachToCheckbox()
								}
							/>

							<NotificationSection.Item
								label={localize("_CommunityComments")}
								subtext={localize("_CommunityCommentsActivityDescription")}
								attachable={formHandler.for("communityPostComments")
									.for("isEnabled")
									.attachToCheckbox()
								}
							/>

							<NotificationSection.Item
								label={localize("_CommunityReactions")}
								subtext={localize("_CommunityReactionsActivityDescription")}
								attachable={formHandler.for("communityReactions")
									.for("isEnabled")
									.attachToCheckbox()
								}
							/>

							<NotificationSection.Item
								label={localize("_CommunityMentions")}
								subtext={localize("_CommunityMentionsActivityDescription")}
								attachable={formHandler.for("communityPostCommentMentions")
									.for("isEnabled")
									.attachToCheckbox()
								}
							/>
						</NotificationSection.ItemList>
					</Tabs.Tab>
				)}
				<Tabs.Tab
					id="event"
					title={localize("_Events")}
				>
					<NotificationSection.ItemList>
						<NotificationSection.Item
							label={localize("_Events")}
							subtext={localize("_EventsActivityDescription")}
							attachable={formHandler.for("events")
								.for("isEnabled")
								.attachToCheckbox()
							}
						/>

						<NotificationSection.Item
							label={localize("_EventAttendance")}
							subtext={localize("_EventAttendanceActivityDescription")}
							attachable={formHandler.for("eventAttendances")
								.for("isEnabled")
								.attachToCheckbox()
							}
						/>

						<NotificationSection.Item
							label={localize("_EventComments")}
							subtext={localize("_EventCommentsActivityDescription")}
							attachable={formHandler.for("eventComments")
								.for("isEnabled")
								.attachToCheckbox()
							}
						/>

						<NotificationSection.Item
							label={localize("_EventReactions")}
							subtext={localize("_EventReactionsActivityDescription")}
							attachable={formHandler.for("eventReactions")
								.for("isEnabled")
								.attachToCheckbox()
							}
						/>

						<NotificationSection.Item
							label={localize("_EventMentions")}
							subtext={localize("_EventMentionsActivityDescription")}
							attachable={formHandler.for("eventCommentMentions")
								.for("isEnabled")
								.attachToCheckbox()
							}
						/>
					</NotificationSection.ItemList>
				</Tabs.Tab>
				<Tabs.Tab
					id="knowledge-item"
					title={localize("_KnowledgeBase")}
				>
					<NotificationSection.ItemList>
						<NotificationSection.Item
							label={localize("_KnowledgeArticles")}
							subtext={localize("_KnowledgeArticlesActivityDescription")}
							attachable={formHandler.for("knowledgeItem")
								.for("isEnabled")
								.attachToCheckbox()
							}
						/>

						<NotificationSection.Item
							label={localize("_KnowledgeArticleComments")}
							subtext={localize("_KnowledgeArticleCommentsActivityDescription")}
							attachable={formHandler.for("knowledgeItemComments")
								.for("isEnabled")
								.attachToCheckbox()
							}
						/>

						<NotificationSection.Item
							label={localize("_KnowledgeArticleReactions")}
							subtext={localize("_KnowledgeArticleReactionsActivityDescription")}
							attachable={formHandler.for("knowledgeItemReactions")
								.for("isEnabled")
								.attachToCheckbox()
							}
						/>

						<NotificationSection.Item
							label={localize("_KnowledgeArticleMentions")}
							subtext={localize("_KnowledgeArticleMentionsActivityDescription")}
							attachable={formHandler.for("knowledgeItemCommentMentions")
								.for("isEnabled")
								.attachToCheckbox()
							}
						/>
					</NotificationSection.ItemList>
				</Tabs.Tab>
			</Tabs>
		</NotificationSection>
	);
};

HubActivitySection.displayName = "HubActivitySection";
